import * as React from 'react';
import GroupOptionsCheckbox from './GroupOptionsCheckbox';

type Props = {
  checked: boolean;
  hasChildren: boolean;
  toggle: (identifier: string) => void;
  isModal: boolean;
};

const GroupOptionsUnder13Checkbox = (props: Props) => (
  <GroupOptionsCheckbox
    checked={props.checked ? !props.hasChildren : true}
    disabled={!props.checked}
    onChange={() => {
      if (props.checked) {
        props.toggle('hasChildren');
      }
    }}
    label={'I will only message people 13 or older'}
    sublabel={
      props.checked
        ? 'It’s okay if students are under 13. We’ll ask for a parent’s email address to keep everyone in the loop.'
        : 'Classes that aren’t affiliated with a school can’t have under 13 participants.'
    }
    italicSublabel={
      (props.hasChildren && props.checked && 'Students under 13 can’t reply.') || undefined
    }
  />
);

export default GroupOptionsUnder13Checkbox;
